import { store } from "@/configureStore";
import { API_PATH, API_URL } from "@/constants";
import api from "@/utils/api";
const { createSelector } = require("reselect");

export const fetchShopReparations = async (shopId, deviceId, brandId, modelId) => {
    const fetchedData = await api.get(`${API_URL}/get-shop-reparations/?shop=${shopId}&device=${deviceId}&brand=${brandId}&model=${modelId}`);
    return fetchedData;
}

export const fetchInlineModels = async (shopId) => {
    if (shopId) {
        return await api.get(`${API_URL}/models/?shop=${shopId}`)
    }
    return []
}

const selectRepairModule = {
    selector: createSelector(
        state => state?.searchData,
        (searchData) => {
            return {
                step: searchData?.step || 1,
                isGoBack: searchData?.isGoBack,
                showBack: searchData?.showBack,
            }
        }
    ),
    updateStep: async (step) => {
        store.ref.dispatch({ type: "UPDATE_SEARCH_DATA_STEP", step });
    },
    updateGoBack: async (isGoBack) => {
        store.ref.dispatch({ type: "UPDATE_SEARCH_DATA_GO_BACK", isGoBack });
    },
    updateShowBack: async (showBack) => {
        store.ref.dispatch({ type: "UPDATE_SEARCH_DATA_SHOW_BACK", showBack });
    }
}

export { selectRepairModule }
